module.exports = __webpack_public_path__ + "img/tee-white-02.9b6c0713.jpg";